import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ component: Component, ...props }) => {
  const credentials = props.credentials;
  const redirectPath = props.redirectPath ? props.redirectPath : "/login";

  return (
    <Route
      {...props}
      render={(props) => {
        return credentials ? (
          <Component {...props} />
        ) : (
          <Redirect to={redirectPath} />
        );
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});

export default connect(mapStateToProps)(PrivateRoute);
